export function setCaretPosition(element, caretPos) {
  if (element.createTextRange) {
    const range = element.createTextRange();
    range.move('character', caretPos);
    range.select();
    return;
  }

  if (element.setSelectionRange) {
    element.focus();
    element.setSelectionRange(caretPos, caretPos);
    return;
  }

  element.focus();
}
